export enum AcquisitionSource {
  SEARCH = 'SEARCH',
  CHATBOT = 'CHATBOT',
  FRIEND = 'FRIEND',
  TEAM_INVITE = 'TEAM_INVITE',
  WEBSITE = 'WEBSITE',
  AD = 'AD',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  UNANSWERED = 'UNANSWERED',
}

export type SelectableAcquisitionSource = Exclude<
  AcquisitionSource,
  AcquisitionSource.UNANSWERED
>;

export const ACQUISITION_SOURCE_NOT_ASKED = 'NOT_ASKED' as const;

export type AcquisitionSourceBucket =
  | AcquisitionSource
  | typeof ACQUISITION_SOURCE_NOT_ASKED;
